import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { useToast } from '../../../components/ToastContext';
import VariantHeader from './VariantHeader';
import VariantTable from './VariantTable';
import { updateVariant } from '../../../api/api';
import { fetchAllProducts } from '../../../hooks/useFetchProducts';
import { useAppContext } from '../../../context/AppContext';

export const ProductVariantModal = ({ open, onClose, setProductVariant, productVariant }) => {
  const { showToast } = useToast();
  const { setIsLoggedIn, setRows, setOriginalRows } = useAppContext();

  const handleSendAllVariantsToggle = () =>
    setProductVariant((prevVariants) => ({
      ...prevVariants,
      variations: prevVariants?.variations?.map((v) => ({ ...v, enabled: true })),
    }));

  const handleSaveChanges = () => {
    const { variations, product } = productVariant;

    updateVariant(product.mpn, variations)
      .then(() => fetchAllProducts(setRows, setOriginalRows, setIsLoggedIn, showToast))
      .catch(() => showToast('An error occurred.', 'error'))
      .finally(() => onClose());
  };

  const headerStyle = { backgroundColor: '#f3fff3', fontWeight: 'bold', fontSize: 16 };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 'none',
        },
      }}
    >
      {/* Header Section */}
      <VariantHeader productVariant={productVariant} onClose={onClose} handleSaveChanges={handleSaveChanges} />

      {/* Variants Table */}
      <DialogContent sx={{ p: 2, overflowX: 'hidden' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1 }}>
          <IconButton onClick={handleSendAllVariantsToggle}>
            <FileUploadIcon color="success" />
          </IconButton>

          <Typography color="success" variant="body2" sx={{ mr: 1 }}>
            Send all variants
          </Typography>
        </Box>

        <TableContainer elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={headerStyle}>Size</TableCell>
                <TableCell sx={headerStyle}>EAN</TableCell>
                <TableCell sx={headerStyle} colSpan={3} align="left">
                  Quantity
                </TableCell>
                <TableCell sx={headerStyle} colSpan={3} align="left">
                  Prices
                </TableCell>
                <TableCell sx={{ minWidth: 150, ...headerStyle }}>Availability</TableCell>
                <TableCell sx={headerStyle}>Send to Skroutz</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {productVariant?.variations?.map((variant) => (
                <VariantTable key={variant.variationid} setProductVariant={setProductVariant} variant={variant} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};
